import { memo } from 'react'
// @mui
import { useTheme } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
// theme
import { bgBlur } from 'src/theme/css'
// hooks
// components
import { NavSectionHorizontal } from 'src/components/nav-section'
//
import { useUserStore } from 'src/store/user'
import { DEFAULT_USER_PERMISSIONS } from 'src/types/user'
import { HEADER } from '../config-layout'
import { useNavData } from './config-navigation'
import { HeaderShadow } from '../_common'

// ----------------------------------------------------------------------

function NavHorizontal() {
  const theme = useTheme()

  const { user } = useUserStore()

  const navData = useNavData()

  return (
    <AppBar
      component='nav'
      sx={{
        top: HEADER.H_DESKTOP_OFFSET,
      }}
    >
      <Toolbar
        sx={{
          ...bgBlur({
            color: theme.palette.background.default,
          }),
        }}
      >
        <NavSectionHorizontal
          data={navData}
          config={{
            currentRole: user?.role || 'admin',
            currentPermissions: {
              ...DEFAULT_USER_PERMISSIONS,
              ...(user?.permissions || {}),
            },
          }}
        />
      </Toolbar>

      <HeaderShadow />
    </AppBar>
  )
}

export default memo(NavHorizontal)
